import { useEffect, useState } from "react";
import { mostraAlertaError, mostraAlertaOk, mostraAlertaPregunta } from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ClienteEliminar, ClienteListar } from "../../../../configuracion/apiUrls";

const EliminarClientes = ({ datos, token, setListaClientes, ActualizarLista }) => {
    const [eliminar, setEliminar] = useState(false);

    useEffect(() => {
        if (eliminar)
            eliminarCliente();
    }, [eliminar]);

    const eliminarProductoPregunta = async () => {
        mostraAlertaPregunta(setEliminar, `¿Deseas eliminar el cliente ${datos.nombreCompleto} de forma permanente?`, "warning");
    };

    const eliminarCliente= async () => {
        if (!datos.id)
            mostraAlertaError("Seleccione el cliente");
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.delete(ClienteEliminar + datos.id)
                    .then((respuesta) => {
                        ActualizarLista(ClienteListar, setListaClientes);
                        mostraAlertaOk("Registro eliminado correctamente");
                    }).catch((er) => {
                        const { response } = er;
                        const msjError =
                            response?.data?.msj ||
                            response?.data?.error?.message ||
                            "Ocurrió un error desconocido.";
                        mostraAlertaError(msjError, "error");
                    });
            } catch (error) {
                mostraAlertaError("Error en la petición");
            }
        }
        setEliminar(false);
    };

    return (
        <button type="button" className="btn btn-outline-danger" onClick={eliminarProductoPregunta}>
            <i className="fas fa-trash" />
        </button>
    );
};

export default EliminarClientes;